<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default { name: "nominationLayout" }
</script>
